import { GetterTree, ActionTree, MutationTree, ActionContext } from 'vuex';
import { User } from '@/models/user.model';
import { findInIncludedArray } from '@/helpers/helpers';
import { Role, UserRoles } from '@/models/role.model';
import { Permission, UserPermissions } from '@/models/permission.model';
import { Location } from '@/models/location.model';
import { cloneDeep } from 'lodash';

interface LoadingState {
  me: User | null;
  meIncludedArray: any[];
}

export const defaultMeState: LoadingState = {
  me: null,
  meIncludedArray: []
};

const state: LoadingState = cloneDeep(defaultMeState);

const mutations: MutationTree<LoadingState> = {
  ADD_ME(returnedState: LoadingState, payload: { user: User; includedArray: any[] }): void {
    returnedState.me = payload.user;
    returnedState.meIncludedArray = payload.includedArray;
  },
  REMOVE_ME(returnedState: LoadingState): void {
    returnedState.me = null;
    returnedState.meIncludedArray = [];
  }
};

const actions: ActionTree<LoadingState, {}> = {
  addMe: ({ commit }: ActionContext<LoadingState, {}>, payload: { user: User; includedArray: any[] }): void => {
    commit('ADD_ME', payload);
  },
  removeMe: ({ commit }: ActionContext<LoadingState, {}>): void => {
    commit('REMOVE_ME');
  }
};

const getters: GetterTree<LoadingState, {}> = {
  me: (returnedState: LoadingState): User | null => {
    return returnedState.me;
  },
  meIncludedArray: (returnedState: LoadingState): any[] => {
    return returnedState.meIncludedArray;
  },
  myRole: (returnedState: LoadingState): UserRoles | null => {
    if (returnedState.me && returnedState.meIncludedArray) {
      return (
        findInIncludedArray(returnedState.me.relationships.roles, returnedState.meIncludedArray, Role)[0]?.attributes
          .name || UserRoles.user
      );
    }

    return UserRoles.user;
  },
  myPermissions: (returnedState: LoadingState): UserPermissions[] => {
    if (returnedState.me && returnedState.meIncludedArray) {
      return findInIncludedArray(
        returnedState.me.relationships.permissions,
        returnedState.meIncludedArray,
        Permission
      ).map((permission: Permission): UserPermissions => permission.attributes.name as UserPermissions);
    }

    return [];
  },
  myViewLocations: (returnedState: LoadingState): Location[] => {
    if (returnedState.me && returnedState.meIncludedArray) {
      return findInIncludedArray(
        returnedState.me.relationships.view_locations,
        returnedState.meIncludedArray,
        Location
      );
    }

    return [];
  },
  myDefaultCentre: (returnedState: LoadingState): Location | null => {
    if (returnedState.me && returnedState.meIncludedArray) {
      return (
        findInIncludedArray(
          returnedState.me.relationships.default_location,
          returnedState.meIncludedArray,
          Location
        )[0] || null
      );
    }

    return null;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
